"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
exports.TOGGLE = {
    MAP: 'map',
    LIST: 'list'
};
exports.VIEW_MODE = {
    TABLE: 'table',
    LIST: 'list'
};
exports.VIEW = {
    DEPT_LIST: 0,
    MACHINE_LIST: 1,
    REPORT_LIST: 2,
    GRAPH_LIST: 4,
    XINDICATE_ALL: 3,
    OTHER: 999,
    DEPARTMENT: 'DEPARTMENT',
    MACHINE: 'MACHINE',
    REPORT: 'REPORT',
    PERFORMANCE_GRAPH: 'PERFORMANCE_GRAPH',
    TABLEVIEW_PERFORMANCE: 'TABLEVIEW_PERFORMANCE'
};
exports.TYPE = {
    LAMINATING: 'LAMINATING',
    SLITTING: 'SLITTING',
    PRINTING: 'PRINTING',
    EXTRUCTION: 'EXTRUCTION',
    BAG_CUTTING: 'BAG_CUTTING',
};
exports.REPORTTYPE = {
    DAILY: 'DAILY',
    LAST_WEEK: 'LAST_WEEK',
    MONTHLY: 'MONTHLY',
    ANNUAL: 'ANNUAL',
    CUSTOM: 'CUSTOM',
};
exports.REPORTNAMES = {
    PERFORMANCE: 'performance',
    ACHIEVEMENT: 'achievement',
    OEE: 'oee',
    DOWNTIME: 'downtime',
    AVERAGE_ORDER_SIZE: 'averageOrderSize',
    WASTAGE: 'wastage',
    UTILIZATION: 'utilization',
    PERFORMANCE_BC: 'Performance',
    ACHIEVEMENT_BC: 'Achievement',
    OEE_BC: 'OEE',
    DOWNTIME_BC: 'Down Time',
    AVERAGE_ORDER_SIZE_BC: 'Average Order Size',
    WASTAGE_BC: 'Wastage',
    UTILIZATION_BC: 'Utilization',
};
exports.IRRIGATION_STATUS = {
    ON: 'ON',
    ON_REQUESTED: 'ON_REQUESTED',
    OFF: 'OFF',
    ERROR: 'ERROR',
    PENDING: 'PENDING',
    OFF_REQUESTED: 'OFF_REQUESTED'
};
exports.DAYS = {
    MONDAY: 'MONDAY',
    TUESDAY: 'TUESDAY',
    WEDNESDAY: 'WEDNESDAY',
    THURSDAY: 'THURSDAY',
    FRIDAY: 'FRIDAY',
    SATURDAY: 'SATURDAY',
    SUNDAY: 'SUNDAY'
};
exports.IRRIGATION_MODE = {
    MANUAL: 'MANUAL',
    SCHEDULE: 'SCHEDULE',
    DAILY: 'DAILY',
    AUTOMATION: 'AUTOMATION',
};
exports.ACTUATOR_TYPE = {
    DISPENSER: 'DISPENSER',
    MOTOR: 'MOTOR',
    TANK: 'TANK',
    BRANCH: 'BRANCH',
};
exports.CASH_FLOW_TYPE = {
    INCOME: 'INCOME',
    EXPENSE: 'EXPENSE',
};
exports.UNITS = {
    Kg: 'Kg',
    g: 'g',
    L: 'L',
    None: 'None'
};
exports.CASH_STATUS = {
    CASH_PENDING: 'Pending',
    PAID: 'Paid',
    CASH_NOT_PAID: 'NotPaid',
    ADVANCE_PAID: 'AdvancePaid',
};
exports.CASH_STATUS_INCOME = {
    CASH_RECEIVED: 'Received',
    CASH_RECEIVABLE: 'Receivable'
};
exports.PROGRAM_CATEGORY = {
    CATEGORY_EDUCATION: 'EDUCATION',
    CATEGORY_AGRICULTURE: 'AGRICULTURE',
    CATEGORY_HEALTH: 'HEALTH'
};
exports.FIELDS_TYPE = {
    TYPE_TEXT: 'TEXT',
    TYPE_INT: 'INT',
    TYPE_ENUM: 'ENUM',
    TYPE_DATE: 'DATE'
};
exports.DELETE_REASON = {
    CATEGORY_DEATH: 'DEATH',
    CATEGORY_INCORRECT_DATA: 'INCORRECT DATA',
    CATEGORY_DUPLICATE_DATA: 'DUPLICATE DATA',
    CATEGORY_FRAUD: 'FRAUD',
    CATEGORY_MOVED: 'MOVED'
};
exports.GENDER = {
    GENDER_MALE: 'MALE',
    GENDER_FEMALE: 'FEMALE'
};
exports.EXPENSE_CATEGORY = {
    LABOUR_CHARGE: 'LABOUR_CHARGE',
    FIXED_ASSET: 'FIXED_ASSET',
    REPAIR_MAINTENANCE: 'REPAIR_MAINTENANCE',
    CURRENT_ASSET: 'CURRENT_ASSET',
    OTHER: 'OTHER'
};
exports.LABOUR_CHARGE_TYPE = {
    DAILY: 'DAILY',
    MONTHLY: 'MONTHLY',
};
exports.VALVES_TYPE = {
    ALL: 'ALL',
    ASSIGNED: 'ASSIGNED',
    UN_ASSIGNED: 'UN_ASSIGNED',
};
exports.YieldFilter = {
    ALL: 'ALL',
    AVAILABLE: 'AVAILABLE',
};
exports.MODULE = {
    SMART_FARM: 'SMART_FARM',
    CASH_FLOW: 'CASH_FLOW',
    DAILY_UPDATE: 'DAILY_UPDATE',
    SETTINGS: 'SETTINGS',
    REPORT: 'REPORT',
    XINDICATE: 'XINDICATE',
};
exports.CASH_FLOW_REPORT_TYPE = {
    CASH_FLOW_REPORT_TYPE: 'CASH_FLOW_REPORT_TYPE',
    MONTHLY_INCOME_REPORT: 'MONTHLY_INCOME_REPORT',
    MONTHLY_EXPENSE_REPORT: 'MONTHLY_EXPENSE_REPORT',
    WASTAGE: 'WASTAGE',
    YIELD: 'YIELD'
};
exports.DomainKnowledgeType = {
    MANUAL: "manual_input",
    UPLOAD: "upload_file",
    NONE: "No",
};
//# sourceMappingURL=enum.js.map